'use strict';

var angular = require('angular');
var SeasonalityAnalysisReviewPanelDirective = function SeasonalityAnalysisReviewPanelDirective(seasonalityConstants) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/seasonality-analysis-review-panel.html'),
    link: function link($scope) {
      $scope.seasonalityType = seasonalityConstants.SEASONALITY_TYPE.PARTITIONED;
      $scope.showSaveAndInitializeModal = function () {
        angular.element('#save-and-initialize-modal').modal('show');
      };
      $scope.isOfflineCalendar = function () {
        return $scope.displayedCalendar.metric === 'Offline';
      };
      $scope.offlineCalendarGridId = 'seasonality-offline-calendar-review';
      if ($scope.screenState.calendarMode === 'seasonality-show-up-mode') {
        $scope.offlineCalendarGridId += '-show-up';
      }
    }
  };
};
SeasonalityAnalysisReviewPanelDirective.$inject = ['SeasonalityConstants'];
module.exports = SeasonalityAnalysisReviewPanelDirective;